import { render, staticRenderFns } from "./UserIndex.vue?vue&type=template&id=cabd31a6&scoped=true&"
import script from "./UserIndex.vue?vue&type=script&lang=ts&"
export * from "./UserIndex.vue?vue&type=script&lang=ts&"
import style0 from "./UserIndex.vue?vue&type=style&index=0&id=cabd31a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabd31a6",
  null
  
)

export default component.exports